import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { GameCenterComponentGridAreas } from '../../styles';

export const ScoringSummaryContainer = styled.div`
    ${BaseStyle.Mixins.gaps.medium}
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    grid-area: ${GameCenterComponentGridAreas.scoringSummary};
    width: 100%;

    ${BaseStyle.Mixins.screenSizes.large} {
        ${BaseStyle.Mixins.gaps.large}
    }
`;

export const PeriodContainer = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    flex-direction: column;
    width: 100%;
`;
